export default "__VITE_ASSET__BHIv8lCa__"